import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Script from 'next/script';
import { Fragment, useEffect, useState } from 'react';
export function Chatbot({ popup = false, chatbotID, height, width, }) {
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        if (loaded)
            return;
        // Add the script to document.body if it's a popup
        if (popup) {
            const script = document.createElement('script');
            script.src =
                'https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js';
            script.type = 'module';
            document.head.appendChild(script);
            const chatbot = document.createElement('zapier-interfaces-chatbot-embed');
            chatbot.setAttribute('is-popup', String(popup));
            chatbot.setAttribute('chatbot-id', chatbotID);
            chatbot.setAttribute('height', `${height !== null && height !== void 0 ? height : 600}px`);
            chatbot.setAttribute('width', `${width !== null && width !== void 0 ? width : 400}px`);
            const div = document.createElement('div');
            div.setAttribute('style', 'position: fixed; z-index: 999;');
            div.appendChild(chatbot);
            document.body.appendChild(div);
            setLoaded(true);
        }
    }, [popup, chatbotID, height, width, loaded]);
    // If it's not a popup, render the chatbot directly
    if (!popup)
        return (_jsxs(Fragment, { children: [_jsx(Script, { type: "module", src: "https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js" }), _jsx("zapier-interfaces-chatbot-embed", { "is-popup": String(popup), "chatbot-id": chatbotID, height: `${height !== null && height !== void 0 ? height : 600}px`, width: `${width !== null && width !== void 0 ? width : 400}px` })] }));
    return null;
}
//# sourceMappingURL=Chatbot.js.map